// extracted by mini-css-extract-plugin
export default {"root":"_c0BiSve","block":"UOsHdP9X","codeSelect":"dS9Bw1cM","numberInput":"w9gZKGfV"};